'use strict'

import master from 'Modules/master'
import carousel from 'Modules/carousel'
import rollingTexts from 'Modules/rollingTexts'

// TODO
// Refacto
master.process()
carousel.activerCarrouselQuiSommesNous()
rollingTexts.init()

/**
 * Rainbow / Change la couleur de la carte MODZ
 */
document.addEventListener('DOMContentLoaded', function () {
    let rainbowEl = document.querySelector('.j_img-card--rainbow')

    if (rainbowEl) {
        changeRainbowColor(rainbowEl)
    }
})

function changeRainbowColor(rainbow) {
    setTimeout(function () {
        let currentStep = parseInt(rainbow.getAttribute('data-step'))
        let nextStep = currentStep < 5 ? currentStep + 1 : 1
        let $currentActive = $('.j_img-cont.active')
        let $nextActive = $('.j_img-cont[data-step="' + nextStep + '"]')

        rainbow.setAttribute('data-step', nextStep)
        $currentActive.addClass('fade-out')
        $nextActive.addClass('active')

        setTimeout(function () {
            $currentActive.removeClass('active fade-out')
        }, 800)

        changeRainbowColor(rainbow)
    }, 2000)
}
